export const useLoading = (...loadingBools: boolean[]) => loadingBools.some(Boolean);
